/**
 * mwApp.services module <br>
 * Work with category services, categories and subcategories: show/add/edit/remove
 *
 * @namespace mwApp/services
 */

/**
 * ConfigRoutes
 * Configurates module routes
 *
 * @class ConfigRoutes
 * @memberof mwApp/services
 * @see mwApp/services
 *
 * @ngdoc config
 * @name mwApp/services.config:ConfigRoutes
 */
/* @ngInject */
export default function ConfigRoutes ($stateProvider) {
  $stateProvider

    /**
     * abstract state for /services
     */
    .state('app.services', {
      abstract: true,
      url: '',
      template: '<ui-view/>'
    })

    /**
     * abstract state for /catchups
     */
    .state('app.services.catchups', {
      abstract: true,
      url: '/catchups',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/settings.controller:CatchupCtrl}
     * @name /catchups
     * @memberof mwApp/settings.config:ConfigRoutes
     */
    .state('app.services.catchups.list', {
      url: '',
      templateUrl: 'components/services/views/catchups.html',
      controller: 'CatchupCtrl as vm',
      resolve: {
        catchups: /* @ngInject */ function (Catchup) {
          return Catchup.loadAll()
        },
        scope: function () {
        // use object 'scope' to share object between different views
          return {}
        }
      },
      label: 'Catch-up TV',
      access: 'viewCatchup'
    })

    /**
     * abstract state for /liverewinds
     */
    .state('app.services.liverewinds', {
      abstract: true,
      url: '/liverewinds',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/settings.controller:LiveRewindCtrl}
     * @name /tasks
     * @memberof mwApp/settings.config:ConfigRoutes
     */
    .state('app.services.liverewinds.list', {
      url: '',
      templateUrl: 'components/services/views/liveRewinds.html',
      controller: 'LiveRewindCtrl as vm',
      resolve: {
        liveRewinds: () => null,
        scope: function () {
          // use object 'scope' to share object between different views
          return {}
        }
      },
      label: 'Live Rewind',
      access: 'viewLiveRewind'
    })

    /**
     * abstract state for /epgs
     */
    .state('app.services.epgs', {
      abstract: true,
      url: '/epgs',
      template: '<ui-view/>'
    })

    /**
     * controller {@link mwApp/services.controller:EpgCtrl}
     * @name /epgs
     * @memberof mwApp/services.config:ConfigRoutes
     */
    .state('app.services.epgs.list', {
      url: '',
      templateUrl: 'components/services/views/epgs.html',
      controller: 'EpgCtrl as vm',
      label: 'EPG',
      access: 'viewEpgTask'
    })
}
